var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_svg__ds",
    x1: 184.96,
    y1: 162.3,
    x2: 350.44,
    y2: 162.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "create_svg__bv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.04,176.32l-54.36-54.36,38.76-38.76,54.36,54.36-38.76,38.76Zm-37.39-54.36l37.39,37.39,21.79-21.79-37.39-37.39-21.79,21.79Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "308.04 167.84 262.16 121.96 292.44 91.69 338.31 137.56 308.04 167.84"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "create_svg__dr"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m89.03,351.58l68.46-18.34c.07-.02.14-.05.21-.07.35-.1.69-.22,1.03-.35.19-.08.38-.16.57-.24.32-.15.64-.3.96-.47.14-.08.28-.16.41-.25.31-.19.6-.39.89-.6.09-.07.18-.13.27-.2.38-.3.76-.61,1.1-.96l153.69-153.69c2.26-2.26,3.55-5.38,3.55-8.57,0-3.19-1.29-6.32-3.55-8.58l-45.87-45.87c-2.26-2.26-5.38-3.55-8.57-3.55s-6.32,1.29-8.57,3.55l-153.69,153.69c-.34.34-.65.71-.95,1.09-.08.1-.15.2-.22.3-.2.28-.39.56-.57.85-.09.15-.18.29-.27.45-.16.3-.31.6-.45.91-.09.2-.18.4-.26.61-.13.34-.25.68-.35,1.03-.02.07-.05.13-.07.2l-16.79,62.66c-1.12,4.17.08,8.66,3.14,11.71,1.55,1.55,3.44,2.63,5.51,3.16l.41,1.53Zm33.81-44.42l8.09,8.09-22.09,5.92,5.92-22.09,8.09,8.09Zm31.51-2.78l-28.73-28.73,136.54-136.54,28.73,28.73-136.54,136.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m346.89,128.99l-45.87-45.87c-2.26-2.26-5.38-3.55-8.57-3.55s-6.32,1.29-8.57,3.55l-30.27,30.27c-2.26,2.26-3.55,5.38-3.55,8.57s1.29,6.32,3.55,8.57l45.87,45.87c2.26,2.26,5.38,3.55,8.57,3.55s6.32-1.29,8.57-3.55l30.27-30.27c2.26-2.26,3.55-5.38,3.55-8.57,0-3.19-1.29-6.32-3.55-8.58Zm-38.85,21.7l-28.73-28.73,13.12-13.12,28.73,28.73-13.12,13.12Zm-33.46,4.73c2.29,2.29,3.55,5.34,3.55,8.57s-1.26,6.28-3.55,8.57l-68.93,68.93c-2.36,2.36-5.47,3.54-8.57,3.54s-6.21-1.18-8.57-3.54c-2.29-2.29-3.55-5.34-3.55-8.57s1.26-6.28,3.55-8.57l68.93-68.93c4.73-4.73,12.42-4.73,17.15,0Z",
    style: {
      fill: "url(#create_svg__ds)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.773a36fc0fab8ce0a63b82bd5133e154.svg";
export { ForwardRef as ReactComponent };